// extracted by mini-css-extract-plugin
export default {"BestRatedBooks":"BestRatedBooks_BestRatedBooks__f4Jx2","List":"BestRatedBooks_List__lse8s"};